import React from 'react'
import { renderRoutes } from 'react-router-config'
import { useLocation } from 'react-router-dom'

import { emrUser, oAuthRoutes } from 'src/utils/routes'

import MaintenancePage from '../MaintenancePage'

const getRoutes = (location: Location) => {
  if (location.pathname.startsWith('/oauth/')) {
    return oAuthRoutes
  }

  return emrUser
}

const Root = ({ maintenance = false }: { maintenance: boolean }) => {
  const location = useLocation()

  return maintenance ? <MaintenancePage /> : renderRoutes(getRoutes(location))
}

export default Root
